/*
 * ATTENTION: The "eval" devtool has been used (maybe by default in mode: "development").
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/collection.js":
/*!******************************!*\
  !*** ./src/js/collection.js ***!
  \******************************/
/***/ (() => {

eval("//Filter\nwindow.modifyFilter = function modifyFilter() {\n  //Move sorting filter\n  var filterSort = document.querySelector('.filter-group-sort-orders');\n\n  if (!filterSort) {\n    return;\n  }\n\n  var container = document.querySelector('.filterSort');\n  var mainFilter = document.querySelector('.filter-menu');\n  container.appendChild(filterSort);\n  filterSort.classList.add('pt-group-expanded'); //Add dropdown classes\n\n  filterSort.classList.add('filter-dropdown');\n  mainFilter.classList.add('filter-dropdown'); //Add click listener\n\n  var triggers = document.querySelectorAll('.filter-trigger');\n\n  for (var j = 0; j < triggers.length; j++) {\n    triggers[j].addEventListener('click', function () {\n      this.parentNode.classList.toggle('open');\n    });\n    triggers[j].addEventListener('blur', function (e) {\n      if (!e.relatedTarget || !this.parentNode.contains(e.relatedTarget)) {\n        this.parentNode.classList.remove('open');\n      }\n    });\n  }\n};\n\nwindow.modifyFilter();\n\n//# sourceURL=webpack://shopify-starter-theme/./src/js/collection.js?");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module can't be inlined because the eval devtool is used.
/******/ 	var __webpack_exports__ = {};
/******/ 	__webpack_modules__["./src/js/collection.js"]();
/******/ 	
/******/ })()
;